import { useContext } from 'react';

import { NotificationsServiceContext } from 'app/context/NotificationsServiceContext';

export default () => useContext(NotificationsServiceContext);
